module.exports = __webpack_public_path__ + "static/media/appstore.fba0f3fa.png";